import React, { useEffect, useState } from 'react';
import { cancel, eyes } from '../../assets/images/login';
import { Box, Img, Input } from '@chakra-ui/react';
import Typography from '../../components_/Typography';
import { Colors } from '../../utils/constants';
import Button from '../../components_/button';
import { containsSpecialChars } from '../../utils/validations';
import { itemCheck } from '../../assets/images/dashboard-business';

type TProps = {
  formik: any;
};

const CreateNewPassword = ({ formik }: TProps) => {
  const [seePassword, setSeePassword] = useState(false);
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);

  const [isMorethan8, setIsMorethan8] = useState(false);
  const [isLessThan24, setIsLessThan24] = useState(false);
  const [oneCapital, setOneCapital] = useState(false);
  const [oneLower, setOneLower] = useState(false);
  const [oneSymbol, setOneSymbol] = useState(false);
  const [oneNumber, setOneNumber] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (formik?.values?.password.length >= 8) {
      setIsMorethan8(true);
    } else {
      setIsMorethan8(false);
    }

    if (formik?.values?.password.length >= 8 && formik?.values?.password.length <= 25) {
      setIsLessThan24(true);
    } else {
      setIsLessThan24(false);
    }

    if (formik?.values?.password.search(/[A-Z]/) >= 0) {
      setOneCapital(true);
    } else {
      setOneCapital(false);
    }
    if (formik?.values?.password.search(/[a-z]/) >= 0) {
      setOneLower(true);
    } else {
      setOneLower(false);
    }

    if (formik?.values?.password.search(/[0-9]/) >= 0) {
      setOneNumber(true);
    } else {
      setOneNumber(false);
    }

    if (containsSpecialChars(formik?.values?.password)) {
      setOneSymbol(true);
    } else {
      setOneSymbol(false);
    }
  }, [formik?.values?.password, formik?.values?.confirmPassword]);

  return (
    <Box bgColor={'white'} px={{ base: '2rem', md: '3.5rem' }} py={'2rem'} borderRadius={'0.5rem'}>
      <Box mb={'2rem'}>
        <Typography color={Colors.black} fontSize={'1.125rem'} fontWeight={700} mb={'1rem'}>
          Set new password
        </Typography>
        <Typography color={Colors.black} fontSize={'0.75rem'} fontWeight={400} mb={'1.5rem'}>
          {`All set! Create your new password. Don't forget to choose a strong password and keep it safe`}
        </Typography>
        <Box position={'relative'}>
          <Input
            borderRadius={'0.25rem'}
            border={`0.5px solid ${Colors.secondaryGreen300}`}
            placeholder='Password'
            type={seePassword ? 'text' : 'password'}
            fontSize={'0.75rem'}
            fontWeight={400}
            flex={1}
            height={'2.8125rem'}
            onChange={(e) => formik.setFieldValue('password', e.target.value)}
            _placeholder={{
              mt: '-10px',
              color: Colors.black,
            }}
            value={formik.values.password}
            px={{ base: '0.75rem', md: '1rem' }}
            _focusVisible={{
              outlineColor: 'none',
              border: `2px solid ${Colors.green}`,
            }}
            fontFamily={'Poppins'}
          />
          <Img
            src={eyes}
            onClick={() => setSeePassword(!seePassword)}
            position={'absolute'}
            right={'15px'}
            top={'17px'}
            cursor={'pointer'}
          />
          {formik?.touched?.password && formik?.errors?.password && (
            <Typography color={'red'} fontSize={'11px'} fontWeight={400}>
              {formik?.errors?.password}
            </Typography>
          )}
        </Box>
        <Box position={'relative'} mt={'1.5rem'}>
          <Input
            borderRadius={'0.25rem'}
            border={`0.5px solid ${Colors.secondaryGreen300}`}
            placeholder='Confirm passowrd'
            type={seeConfirmPassword ? 'text' : 'password'}
            fontSize={'0.75rem'}
            fontWeight={400}
            flex={1}
            height={'2.8125rem'}
            onChange={(e) => formik.setFieldValue('confirmPassword', e.target.value)}
            _placeholder={{
              mt: '-10px',
              color: Colors.black,
            }}
            value={formik.values.confirmPassword}
            px={{ base: '0.75rem', md: '1rem' }}
            _focusVisible={{
              outlineColor: 'none',
              border: `2px solid ${Colors.green}`,
            }}
            fontFamily={'Poppins'}
          />
          <Img
            src={eyes}
            onClick={() => setSeeConfirmPassword(!seeConfirmPassword)}
            position={'absolute'}
            right={'15px'}
            top={'17px'}
            cursor={'pointer'}
          />
          {formik?.touched?.confirmPassword && formik?.errors?.confirmPassword && (
            <Typography color={'red'} fontSize={'11px'} fontWeight={400}>
              {formik?.errors?.confirmPassword}
            </Typography>
          )}
        </Box>
        <Box mt={'10px'}>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              isMorethan8 ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={isMorethan8 ? itemCheck : cancel} alt='check.png' />
            <p>Minimum of eight charaters</p>
          </div>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              isLessThan24 ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={isLessThan24 ? itemCheck : cancel} alt='check.png' />
            <p>Maximum of 24 charaters</p>
          </div>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              oneCapital ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={oneCapital ? itemCheck : cancel} alt='check.png' />
            <p>Atleast one uppercase letter</p>
          </div>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              oneLower ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={oneLower ? itemCheck : cancel} alt='check.png' />
            <p>Atleast one lowercase letter</p>
          </div>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              oneSymbol ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={oneSymbol ? itemCheck : cancel} alt='check.png' />
            <p>Atleast one symbol (@#%%$^*^)</p>
          </div>
          <div
            className={[
              'flex gap-2 mb-2 text-xs font-[Poppins]',
              oneNumber ? 'text-[#049E26]' : 'text-[#F51010]',
            ].join(' ')}
          >
            <img src={oneNumber ? itemCheck : cancel} alt='check.png' />
            <p>Atleast one number</p>
          </div>
        </Box>
      </Box>

      <Button
        width={'100%'}
        onClick={() => formik.handleSubmit()}
        py={{ base: '0.75rem', md: '1rem' }}
        height={{ base: '2.5rem', md: '2.875rem' }}
        text={'RESET PASSWORD'}
        type='submit'
        position={'relative'}
        zIndex={10000}
      />
    </Box>
  );
};

export default CreateNewPassword;
